"use client";

import React, { useState } from "react";
import { Navigation, X, Map as MapIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
const locations = [{
  id: "atlanta-hub",
  name: "Atlanta Care Hub",
  address: "PDK Airport, Atlanta, GA",
  phone: "888-370-2846",
  email: "ops@finalapproach.care",
  x: 28,
  y: 35
}, {
  id: "charlotte-hub",
  name: "Charlotte Sector",
  address: "CLT Executive, Charlotte, NC",
  phone: "888-370-2846",
  email: "ops@finalapproach.care",
  x: 68,
  y: 28
}, {
  id: "orlando-hub",
  name: "Orlando Care Hub",
  address: "ORL Executive, Orlando, FL",
  phone: "888-370-2846",
  email: "ops@finalapproach.care",
  x: 22,
  y: 65
}, {
  id: "charleston-hub",
  name: "Charleston Sector",
  address: "JZI Executive, Charleston, SC",
  phone: "888-370-2846",
  email: "ops@finalapproach.care",
  x: 72,
  y: 62
}];
export default function CurrentOperationalArea() {
  const [activeLocation, setActiveLocation] = useState<string | null>(null);
  return <section data-section-id="222934" id="current-operational-area" className="w-full bg-background py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 text-primary mb-6 border border-primary/20">
              <MapIcon className="w-4 h-4" />
              <span className="text-sm font-bold tracking-widest uppercase font-mono">Sector Status: Cleared</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight tracking-tighter uppercase">
              Operational <br className="hidden md:block" />
              <span className="text-muted-foreground">Area.</span>
            </h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-md font-default leading-relaxed">
            Our current flight plan covers the Southeast corridor. We are actively managing care transitions across Georgia, Florida, and the Carolinas.
          </p>
        </div>

        {}
        <div className="relative w-full h-[500px] md:h-[700px] bg-secondary rounded-md overflow-hidden shadow-2xl border border-border">
          
          {}
          <svg className="absolute inset-0 w-full h-full object-cover opacity-40 pointer-events-none" viewBox="0 0 1000 700" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-muted-foreground/20" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
            
            {}
            <path d="M-100,200 Q150,100 300,300 T800,150 Q950,200 1100,100 L1100,800 L-100,800 Z" fill="currentColor" className="text-primary/5" />
            <path d="M100,-100 Q300,150 500,50 T900,250 1100,-50 L1100,-100 Z" fill="currentColor" className="text-primary/5" />

            {}
            <path d="M280,245 Q450,150 680,196" fill="none" stroke="var(--ring)" strokeWidth="1.5" strokeDasharray="8 4" className="opacity-60" />
            <path d="M280,245 Q200,350 220,455" fill="none" stroke="var(--ring)" strokeWidth="1.5" strokeDasharray="8 4" className="opacity-60" />
            <path d="M680,196 Q750,350 720,434" fill="none" stroke="var(--ring)" strokeWidth="1.5" strokeDasharray="8 4" className="opacity-60" />
            <path d="M220,455 Q450,550 720,434" fill="none" stroke="var(--ring)" strokeWidth="1.5" strokeDasharray="8 4" className="opacity-60" />
          </svg>

          {}
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10" style={{
          left: `${loc.x}%`,
          top: `${loc.y}%`
        }}>
              {}
              <Button onClick={() => setActiveLocation(activeLocation === loc.id ? null : loc.id)} variant="ghost" size="icon" className="relative -translate-x-1/2 -translate-y-1/2 focus:outline-none h-auto w-auto p-0" aria-label={`View details for ${loc.name}`}>
                {}
                <div className="absolute inset-0 bg-ring rounded-md animate-ping opacity-40 duration-1000"></div>
                
                {}
                <div className={`relative w-5 h-5 md:w-6 md:h-6 bg-ring rounded-md flex items-center justify-center shadow-lg border border-primary transition-transform duration-300 ${activeLocation === loc.id ? 'scale-125' : 'hover:scale-110'}`}>
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-primary-foreground rounded-sm"></div>
                </div>
              </Button>

              {}
              {activeLocation === loc.id && <div className="absolute z-20 bottom-full left-1/2 -translate-x-1/2 mb-4 w-72 md:w-80 bg-popover rounded-md shadow-4xl border border-border p-5 animate-in fade-in zoom-in-95 duration-200 backdrop-blur-md">
                  <Button onClick={() => setActiveLocation(null)} variant="ghost" size="icon" className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors bg-muted/50 rounded-md h-8 w-8" aria-label="Close details">
                    <X className="w-4 h-4" />
                  </Button>
                  
                  <div className="pr-6">
                    <h3 className="font-default font-bold text-lg text-popover-foreground mb-1 tracking-tight uppercase">{loc.name}</h3>
                    <p className="text-sm text-muted-foreground mb-4 font-mono leading-relaxed">{loc.address}</p>
                    
                    <div className="space-y-2 mb-6 bg-muted/30 p-3 rounded-md border border-border/50">
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-muted-foreground font-mono uppercase tracking-wider">Frequency</span>
                        <span className="text-sm text-popover-foreground font-medium font-mono">{loc.phone}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-muted-foreground font-mono uppercase tracking-wider">Comms</span>
                        <span className="text-sm text-popover-foreground font-medium font-mono">Active</span>
                      </div>
                    </div>
                    
                    <Button className="w-full group bg-primary text-primary-foreground hover:bg-primary/90 rounded-md" size="default" asChild>
                      <a href="/FlightDeckPage">
                        <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                        View Flight Deck
                      </a>
                    </Button>
                  </div>
                  
                  {}
                  <div className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 w-5 h-5 bg-popover border-b border-r border-border transform rotate-45"></div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}